// Returns the first element of a 2-Tuple
export function first(entry) {
    return entry[0];
}
// Returns the second element of a 2-Tuple
export function second(entry) {
    return entry[1];
}
//# sourceMappingURL=entry.mjs.map